import React from 'react'
import type { Icon } from 'shared/utils'

const Upload = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'upload',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M8.712 7.706l2.29-2.3v9.592a1 1 0 002 0V5.406l2.291 2.3a1 1 0 001.42 0 1 1 0 000-1.42l-4-4a1 1 0 00-.33-.211 1 1 0 00-.76 0 1 1 0 00-.33.21L7.29 6.286a1.004 1.004 0 101.42 1.42zm12.292 4.292a1 1 0 00-1 1v6.001a1 1 0 01-1 1H5.001a1 1 0 01-1-1v-6.001a1 1 0 10-2.001 0v6.001A3 3 0 005 22h14.004a3 3 0 003-3v-6.002a1 1 0 00-1-1z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Upload }
